import { useEffect, type ReactNode } from 'react'
import { X } from 'lucide-react'

/**
 * Panoul din dreapta cu detaliile unui rand (Madalin, 12.10.2026: „imi place partea de pop up in
 * dreapta cu detaliile (...) vreau sa o pastram"). Lista ramane in spate, vizibila; `Escape` sau
 * un clic alaturi il inchid.
 */
export function PanouLateral({
  deschis,
  onInchide,
  titlu,
  subtitlu,
  children,
}: {
  deschis: boolean
  onInchide: () => void
  titlu: ReactNode
  subtitlu?: ReactNode
  children: ReactNode
}) {
  useEffect(() => {
    if (!deschis) return
    const k = (e: KeyboardEvent) => e.key === 'Escape' && onInchide()
    window.addEventListener('keydown', k)
    return () => window.removeEventListener('keydown', k)
  }, [deschis, onInchide])

  if (!deschis) return null
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/35" onClick={onInchide} aria-hidden />
      <aside
        role="dialog"
        aria-modal="true"
        className="absolute inset-y-0 right-0 flex w-full max-w-[480px] flex-col bg-b4l-surface shadow-2xl motion-safe:animate-[panou_.18s_ease-out]"
      >
        <header className="flex items-start justify-between gap-3 border-b border-b4l-border px-5 pb-3 pt-4">
          <div className="min-w-0">
            <div className="text-base font-semibold">{titlu}</div>
            {subtitlu && <div className="mt-1.5 flex flex-wrap gap-1.5">{subtitlu}</div>}
          </div>
          <button
            type="button"
            onClick={onInchide}
            aria-label="Închide"
            className="rounded p-1 text-b4l-text-muted hover:bg-b4l-bg"
          >
            <X size={18} />
          </button>
        </header>
        <div className="grid gap-5 overflow-y-auto px-5 pb-6 pt-4">{children}</div>
      </aside>
    </div>
  )
}

/** Un titlu mic de sectiune in panou. */
export function SectiunePanou({ titlu, children }: { titlu: string; children: ReactNode }) {
  return (
    <section>
      <h4 className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-b4l-text-dim">
        {titlu}
      </h4>
      {children}
    </section>
  )
}
